import { render } from "./StylistForm.vue?vue&type=template&id=fd7d0a56&scoped=true"
import script from "./StylistForm.vue?vue&type=script&lang=js"
export * from "./StylistForm.vue?vue&type=script&lang=js"

import "./StylistForm.vue?vue&type=style&index=0&id=fd7d0a56&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7d0a56"]])

export default __exports__